(function () {
  const calcTop = (section) => {
    const imageWrapper = section.querySelector(".article-card__image-wrapper");
    let top = 0;

    if (imageWrapper) {
      top = imageWrapper.offsetHeight / 2;
    } else {
      top = 50;
    }

    return top;
  };

  const initSlider = () => {
    const sliders = document.querySelectorAll(".blog__slider");

    sliders.forEach((slider, index) => {
      const compact = Boolean(slider.closest('[id$="__featured_blog"]'));
      if (slider.swiper) slider.swiper.destroy(true, true);
      const articlesSlider = new Swiper(slider, {
        allowTouchMove: true,
        mousewheel: {
          enabled: true,
          forceToAxis: true,
          releaseOnEdges: true,
        },
        slidesPerView: compact ? 2.2 : 1,
        spaceBetween: compact ? 12 : 8,
        speed: 1000,
        navigation: {
          nextEl: slider.querySelector(".swiper-button-next"),
          prevEl: slider.querySelector(".swiper-button-prev"),
        },
        breakpoints: compact ? {750:{slidesPerView:3,slidesPerGroup:1},990:{slidesPerView:6,slidesPerGroup:1}} : {
          576: {
            slidesPerView: 2.05,
            slidesPerGroup: 2,
          },
          990: {
            slidesPerView: 3.05,
            slidesPerGroup: 3,
          },
          1200: {
            slidesPerView: 3,
            slidesPerGroup: 3,
          },
        },
      });
    });
  };

  const initSection = () => {
    const sections = document.querySelectorAll(".section-featured-blog");

    const sectionResizeObserver = new ResizeObserver((entries) => {
      const [entry] = entries;
      sections.forEach((section) => {
        let top = calcTop(section);
        if (section.querySelector(".blog__slider-nav"))
          section.querySelector(".blog__slider-nav").style.top = top + "px";
      });
    });

    sections.forEach((section) => {
      sectionResizeObserver.observe(section);
    });

    initSlider();
  };

  initSection();

  document.addEventListener("shopify:section:load", function () {
    initSection();
  });
})();
